import Offline from './Offline'
import Api from '../core/Api'
import localforage from 'localforage'

class Detenteur {

    constructor() {

        this.data = {}

    }

    static serialize(data) {

        let det = Object.assign({}, data);
        det.raisonSociale = det.raison_sociale;
        det.codePostal = det.code_postal;
        det.codeClient = det.code_client;
        det.complementAdresse = det.complement_adresse;
        delete det.complement_adresse;
        delete det.code_client;
        delete det.raison_sociale;
        delete det.code_postal;
        delete det.installations;
        delete det.created_at;
        delete det.updated_at;
        delete det.id;

        return det

    }

    static addDetenteurOffline(data) {
        return new Promise((resolve, reject) => {
            let tempId = 'N-' + +new Date();

            this
                .getList()
                .then(list => {

                    data.id = tempId;
                    list.push(data);

                    localforage
                        .setItem('listDetenteurs', JSON.stringify(list))
                        .then(() => {

                            return Offline.saveAction({
                                action: 'add',
                                type: 'Detenteur',
                                id: tempId
                            })

                        })
                        .then(() => {

                            resolve('Ajout offline ok')

                        })
                        .catch(err => reject(err))
                })
        })
    }

    static getDetenteurOnline(id) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {
                    api
                        .get('/detenteur/' + id)
                        .then(result => {
                            if(!_.isEmpty(result.data) && (result.data[0] !== "undefined")){
                                resolve(result.data[0]);
                            }else{
                                reject(id);
                            }
                        })
                })
        })
    }

    static addDetenteurOnline(data) {
        return new Promise((resolve, reject) => {
            Api
                .init()
                .then(api => {

                    api
                        .post('/detenteur', data)
                        .then(result => {

                            if (!result.data.hasOwnProperty('errors')) {
                                resolve(result.data)
                            } else {
                                let errs = {
                                    apiMsg: result.data.errors,
                                    payload: data
                                };
                                reject(errs)
                            }

                        })
                        .catch(err => {
                            reject(err)
                        })

                })
                .catch(err => reject(err))
        })
    }

    static async updateDetenteur(data) {
        let dets = await Detenteur.getList();
        let id;

        if (!_.includes(data.id, 'N-')) {
            id = parseInt(data.id)
        } else {
            id = data.id
        }

        let index = _.findIndex(dets, ['id', id]);
        dets[index] = data;

        await localforage.setItem('listDetenteurs', JSON.stringify(dets));

        await Offline.saveAction({
            type: 'Detenteur',
            action: 'update',
            id: id
        });

        return true;
    }

    static async updateDeteneteurOnline(id){
        return new Promise((resolve, reject) => {
            Detenteur
                .getDetenteur(id)
                .then(res => {
                    let payload = Detenteur.serialize(res);

                    Api
                        .init()
                        .then(api => {
                            api
                                .patch('/detenteur/'+id, payload)
                                .then(res => {

                                    if (!res.data.hasOwnProperty('errors')) {
                                        resolve(res.data)
                                    } else {
                                        reject(res.data.errors)
                                    }

                                })
                                .catch(err => reject(err))
                        })
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    static getDetenteur(id) {
        return new Promise((resolve, reject) => {
            this.getList().then( res => {

                if (!_.includes(id, 'N-')) {
                    id = parseInt(id)
                }

                const det = _.find(res, ['id', id]);

                if (det !== undefined) {
                    resolve(det);
                } else {
                    resolve(this.getDetenteurOnline(id));
                    reject(id);
                }

            }).catch(err => reject(err))

        })

    }

    static searchByDetenteur(data) {
        return new Promise((resolve, reject) => {
            this.getList().then(res => {
                // Si data est un ID (string ou number), on le transforme en objet { id: ... }
                if (typeof data === 'string' || typeof data === 'number') {
                    const id = !String(data).includes('N-') ? parseInt(data) : data;
                    data = { id: id };
                }

                // Recherche dans la liste locale
                const det = _.find(res, data);

                if (det !== undefined) {
                    resolve(det);
                } else {
                    // Si aucun résultat local, on tente une recherche en ligne si un ID est présent
                    const id = data.id;
                    if (id !== undefined) {
                        resolve(this.getDetenteurOnline(id));
                    } else {
                        reject("Détenteur non trouvé");
                    }
                }
            }).catch(err => reject(err));
        });
    }


    static async getDetenteurWithAsync(id) {
        return new Promise((resolve, reject) => {
            this.getList().then( res => {

                if (!_.includes(id, 'N-')) {
                    id = parseInt(id)
                }

                const det = _.find(res, ['id', id]);

                if (det !== undefined) {
                    resolve(det);
                } else {
                    resolve(this.getDetenteurOnline(id));
                    reject(id);
                }

            }).catch(err => reject(err))

        })

    }

    static getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listDetenteurs')
                .then(detenteurs => {
                    resolve(JSON.parse(detenteurs))
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    static stockDetenteursOnLocal(data) {
        return new Promise((resolve, reject) => {
            let dets = data.map(det => {
                if(det.actif === true){
                    return det;
                }
            });

            let installs = [];

            _.each(dets, det => {

                _.each(det.installations, install => {
                    if (install.actif === true) {
                        install['detenteur'] = det.id;
                        installs.push(install)
                    }
                });

                delete det['installations']

            });

            localforage
                .setItem('listInstallations', JSON.stringify(installs))
                .then(function () {

                    localforage
                        .setItem('listDetenteurs', JSON.stringify(dets))
                        .then(function () {
                            localforage.setItem('listInformationInstallation', JSON.stringify([]))
                                .then(function() {
                                    resolve(true);
                                });
                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        });
    }

    static addNewDetenteurs(data) {
        return new Promise(async (resolve, reject) => {
            let dets = data.map(det => {
                if(det.actif === true){
                    return det;
                }
            });

            let installations = JSON.parse(await localforage.getItem('listInstallations'));
            let detenteurs = JSON.parse(await localforage.getItem('listDetenteurs'));

            _.each(dets, det => {
                _.each(det.installations, install => {
                    if (install.actif === true) {
                        install['detenteur'] = det.id;
                        installations.push(install);
                    }
                });

                if (detenteurs.indexOf(det) === -1) {
                    det.raison_sociale = det.raisonSociale;
                    det.code_postal = det.codePostal;
                    det.code_client = det.codeClient;
                    det.complement_adresse = det.complementAdresse;
                    delete det.raisonSociale;
                    delete det.codePostal;
                    delete det.codeClient;
                    delete det.complementAdresse;
                    delete det.installations;
                    detenteurs.push(det);
                }

                delete det['installations'];
            });


            localforage
                .setItem('listInstallations', JSON.stringify(installations))
                .then(function () {
                    localforage
                        .setItem('listDetenteurs', JSON.stringify(detenteurs))
                        .then(function () {
                            localforage.setItem('listInformationInstallation', JSON.stringify([]))
                                .then(function() {
                                    resolve(true);
                                });
                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        });
    }
}

export default Detenteur



// WEBPACK FOOTER //
// ./src/js/models/Detenteur.js